import { capitalizeFirstLetter as v } from "./index.es169.js";
import t from "react";
import d from "./index.es361.js";
import A from "./index.es80.js";
const b = (r) => r.choices.map((e) => ({
  value: e,
  label: e
})), C = (r, e) => r.length === 1 ? r[0] : e && r.length === e.length ? "Alle valgt" : `Valgt ${r.length}${e ? ` av ${e.length}` : ""}`, E = ({
  parentId: r,
  input: e,
  property: l,
  label: u,
  dimensionLabels: m,
  onValueChange: s
}) => {
  const g = (a) => m[a] || v(a), y = (a) => a === "primary" || a === "secondary";
  let c, p;
  typeof e == "object" && "displayChoices" in e && e.displayChoices && (c = e.displayChoices || [], p = e.choices.map((a) => String(a)).reduce(
    (a, n, i) => ({
      ...a,
      [n]: c[i]
    }),
    {}
  ));
  const h = (a, n) => y(n) ? a ? g(a) : "Ikke valgt" : a ? p && p[a] || a : "Alle";
  if (!e || typeof e == "string")
    return /* @__PURE__ */ t.createElement(t.Fragment, null);
  if ("choices" in e && e.choices.length < 1)
    return /* @__PURE__ */ t.createElement(t.Fragment, null);
  if (Array.isArray(e))
    return /* @__PURE__ */ t.createElement(t.Fragment, null, e.map((a) => {
      const n = a.name;
      return /* @__PURE__ */ t.createElement(
        E,
        {
          key: `${r}-select-${n}`,
          parentId: r,
          label: `${m[a.name] || a.name}`,
          input: a,
          property: l,
          dimensionLabels: m,
          onValueChange: s
        }
      );
    }));
  {
    if (Array.isArray(e.value) && !("max" in e && e.max === 1)) {
      const n = e.value;
      return /* @__PURE__ */ t.createElement(
        d,
        {
          label: u,
          options: b(
            e
          ),
          values: n,
          name: l,
          text: C,
          onChange: (i) => s(i, l)
        }
      );
    }
    const a = Array.isArray(e.value) ? e.value?.[0] || "" : e.value;
    if (typeof a == "string") {
      const n = e.property === "filters" && "name" in e && e.name || void 0, i = e.choices.map(
        (o) => ({
          value: String(o),
          label: h(String(o), l)
        })
      ), f = (o) => Array.isArray(e.value) ? s([o], l, n) : s(o, l, n);
      return /* @__PURE__ */ t.createElement(
        A,
        {
          label: u,
          name: l,
          value: String(a),
          options: i,
          onChange: f
        }
      );
    }
  }
  return /* @__PURE__ */ t.createElement(t.Fragment, null);
};
export {
  E as default
};
//# sourceMappingURL=index.es274.js.map
